import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

interface Breadcrumb {
  title: string;
  pageBreadcrumbPath: Array<string>;
}

interface StoreInfo {
  breadcrumbs: Breadcrumb;
}

@Module
export default class BreadcrumbsModule extends VuexModule implements StoreInfo {
  breadcrumbs = {} as Breadcrumb;
  invitationStatus = "" as string;

  /**
   * Get breadcrumb object for current page
   * @returns object
   */
  get getBreadcrumbs(): Breadcrumb {
    return this.breadcrumbs;
  }

  /**
   * Get breadcrumb array for current page
   * @returns object
   */
  get pageBreadcrumbPath(): Array<string> {
    return this.breadcrumbs.pageBreadcrumbPath;
  }
  get getInvitationStatus(): string {
    return this.invitationStatus;
  }

  /**
   * Get current page title
   * @returns string
   */
  get pageTitle(): string {
    return this.breadcrumbs.title;
  }

  @Mutation
  [Mutations.SET_BREADCRUMB_MUTATION](payload) {
    this.breadcrumbs = payload;
  }
  @Mutation
  [Mutations.SET_INVITATION_STATUS_MUTATION](payload) {
    console.log(Mutations.SET_INVITATION_STATUS_MUTATION + "aaa", payload);
    this.invitationStatus = payload.status;
  }

  @Action
  [Actions.SET_BREADCRUMB_ACTION](payload) {
    this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
  }
  @Action
  [Actions.SET_INVITATION_STATUS_ACTION](payload) {
    console.log(Actions.SET_INVITATION_STATUS_ACTION, payload);
    this.context.commit(Mutations.SET_INVITATION_STATUS_MUTATION, payload);
  }
}
